import { Accessibility, MapType } from '../components/management/manage-map/registry';
import { Subscription } from 'rxjs';

export interface LatLng {
  lat: number;
  lng: number
}

export class Poly {
  constructor(private latLngs: LatLng[]) { };

  getLatLngs() {
    return this.latLngs;
  }
}

export class Segment {
  id: number = null;
  description: string;
  visible: boolean = true;
  genericAttributes?;
  saving: Subscription;

  constructor(public polyline: any | Poly, public accessibility: Accessibility) { }

  get coords() {
    return this.polyline.getLatLngs();
  }

  get coordsLastIdx() {
    return this.coords.length - 1;
  }

}

export class Route {
  id: number = null;
  projectId: number = null;
  mapType: MapType;
  segments: Segment[] = [];
  created = '';
  mode = '';

  constructor(latLngs: LatLng[] = null) {
    if (latLngs !== null) {
      this.init(latLngs);
    }
  }

  init(latLngs: LatLng[], access: Accessibility = 'SAFE') {
    this.segments = [];
    this.add(new Segment(new Poly(latLngs), access));
  }

  add(segment: Segment) {
    this.segments.push(segment);
    return this;
  }

  insert(segment: Segment, idx: number) {
    this.segments.splice(idx, 0, segment);
    return this;
  }

  remove(idx) {
    this.segments.splice(idx, 1);
    return this;
  }

  lastSegmentIdx() {
    return this.segments.length - 1;
  }

  contains(polyline: any) {
    return this.segments.findIndex(segment => segment.polyline == polyline);
  }

  data(defaultDescription = null, projectId) {
    return this.segments.map(segment => {
      let s = {
        "entityID": {
          "@class": ".route.SegmentID",
          "id1": {
            "@class": ".RouteID",
            "id1": {
              "@class": ".ProjectID",
              "id": projectId
            },
            "id2": this.id
          },
          "id2": segment.id
        },
        "parentID": {
          "@class": ".route.RouteID",
          "id1": {
            "@class": ".ProjectID",
            "id": projectId
          },
          "id2": this.id
        },
        "projectID": {
          "@class": ".ProjectID",
          "id": projectId
        },
        "scheme": "SEGMENT",
        "attributes": {
          "accessibility": [
            segment.accessibility
          ],
          "geometry": [{
            "type": "LineString",
            "coordinates": segment.coords.map(c => [c.lng, c.lat])
          }]
        }
      };

      if (segment.description || defaultDescription !== null) {
        s['attributes']['accessibility_description'] = [segment.description || defaultDescription];
      }
      return s;
    });
  }

}
